import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../api/firebase/references";
import { WorkflowConfig } from "../../data-model/workflowConfig";
import { AppDispatch } from "../store/store";

export interface WorkflowConfigState {
  data?: WorkflowConfig;
  isLoading: boolean;
  error?: string;
}

const initialState: WorkflowConfigState = {
  data: undefined,
  isLoading: false,
  error: undefined,
};

export const workflowConfigSlice = createSlice({
  name: "workflowConfig",
  initialState,
  reducers: {
    setWorkflowConfig: (state, action: PayloadAction<WorkflowConfig>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = undefined;
    },
    setFetching: (state) => {
      state.isLoading = true;
      state.error = undefined;
      state.data = undefined;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.data = undefined;
    },
  },
});

export const { setWorkflowConfig, setFetching, setError } =
  workflowConfigSlice.actions;

export const fetchWorkflowConfigDataForAnOrder =
  (orderId: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(setFetching());
      const response = await FirestoreService.getDocument(
        FirestoreDocumentReference.submissionConfig(orderId),
      );
      dispatch(setWorkflowConfig(response as WorkflowConfig));
    } catch (error) {
      dispatch(setError(error as string));
    }
  };

export default workflowConfigSlice.reducer;
